import {Injectable} from '@angular/core';

@Injectable()
export class AnimationService {

    rightToLeft: String = 'rightToLeft';
    leftToRight: String = 'leftToRight';
    downToUp: String = 'downToUp';

    startRightToLeftAnimation(element): void {
      if (this.validateElementSpacing(element)) {
        element.classList.add(this.rightToLeft);
      }
    }

    startLeftToRightAnimation(element): void {
      if (this.validateElementSpacing(element)) {
        element.classList.add(this.leftToRight);
      }
    }

    startDownToUpAnimation(element): void {
      if (this.validateElementSpacing(element)) {
        element.classList.add(this.downToUp);
      }
    }

    private validateElementSpacing(element) {
      return !(element.offsetTop - window.pageYOffset >= window.screen.height || window.pageYOffset > element.offsetTop);
    }
}
